import { createContext, useContext, useState } from 'react'
import type { ReactNode } from 'react'

export interface SelectedTier {
  monthly_tier: number
  months: number
  donation_amount: number
}

interface UIContextValue {
  isModalOpen: boolean
  selectedTier: SelectedTier | null
  openModal: (tier: SelectedTier | null) => void
  closeModal: () => void
  isVerifying: boolean
  setIsVerifying: (v: boolean) => void
  donationSuccess: boolean
  setDonationSuccess: (v: boolean) => void
}

const UIContext = createContext<UIContextValue>({
  isModalOpen: false,
  selectedTier: null,
  openModal: () => {},
  closeModal: () => {},
  isVerifying: false,
  setIsVerifying: () => {},
  donationSuccess: false,
  setDonationSuccess: () => {},
})

export const UIProvider = ({ children }: { children: ReactNode }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedTier, setSelectedTier] = useState<SelectedTier | null>(null)
  const [isVerifying, setIsVerifying] = useState(false)
  const [donationSuccess, setDonationSuccess] = useState(false)

  const openModal = (tier: SelectedTier | null) => {
    setSelectedTier(tier)
    setIsModalOpen(true)
    setDonationSuccess(false)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setIsVerifying(false)
    setDonationSuccess(false)
  }

  return (
    <UIContext.Provider
      value={{
        isModalOpen,
        selectedTier,
        openModal,
        closeModal,
        isVerifying,
        setIsVerifying,
        donationSuccess,
        setDonationSuccess,
      }}
    >
      {children}
    </UIContext.Provider>
  )
}

export const useUI = () => useContext(UIContext)
